import React, { useState } from 'react';
import { Button, Modal } from '@mantine/core';
import { Plus } from 'tabler-icons-react';
import { useTranslation } from 'react-i18next';
import { UserForm } from './UserForm';

export function UserCreateDialog() {
  const { t } = useTranslation();
  const [opened, setOpened] = useState(false);

  return (
    <>
      <Button
        color="green"
        size="md"
        variant="light"
        leftIcon={<Plus />}
        onClick={() => setOpened(true)}
      >
        {t('UserCreateDialog.Title')}
      </Button>
      <Modal
        opened={opened}
        onClose={() => setOpened(false)}
        size="lg"
        title={t('UserCreateDialog.Title')}
      >
        <UserForm
          sectionCreate={false}
          create={true}
          onFinish={() => setOpened(false)}
        />
      </Modal>
    </>
  );
}
